// import React from "react";
// import { VerticalTabs } from "../../../../components";
// import ResumeSearch from "./JobBoardAccountsTabs/ResumeSearch";
// import JobPosting from "./JobBoardAccountsTabs/JobPosting";

// const MarketPlaceAccounts = () => {
//   const tabList = [
//     {
//       title: "Resume Search",
//       id: "marketplace_accounts_resumesearch",
//       page: (
//         <div className="flex-1 p-2 flex flex-col">
//           <ResumeSearch />
//         </div>
//       ),
//     },
//     {
//       title: "Job Posting",
//       id: "marketplace_accounts_jobposting",
//       page: (
//         <div className="flex-1 p-2 flex flex-col">
//           <JobPosting />
//         </div>
//       ),
//     },
//   ];
//   return (
//     <div className="my-2">
//       <VerticalTabs
//         tabs={tabList}
//         activeColor="primary"
//         activeVariant="contained"
//       />
//     </div>
//   );
// };

// export default MarketPlaceAccounts;

import React from "react";
import { VerticalTabs } from "../../../../components";
import ResumeSearch from "./SetupAccountsTabs/ResumeSearch";
import JobPosting from "./SetupAccountsTabs/JobPosting";
import BulkEmail from "./BulkEmailTabs/BulkEmail";
import ProductivityAccounts from "./ProductivityTabs/ProductivityAccounts";
import OpenaiSettings from "./AITabs/OpenaiSettings";
import EmailVerification from "./EmailVerificationTabs/EmailVerification";

const MarketPlaceAccounts = ({ category, type, integrations, onUpdate, selectedModule }) => {
  const monsterTabList = [
    {
      title: "Resume Search",
      id: "marketplace_accounts_resumesearch",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <ResumeSearch
            category={category}
            type={type}
            integrations={integrations}
            onUpdate={onUpdate}
            selectedModule={selectedModule}
          />
        </div>
      ),
    },
    {
      title: "Job Posting",
      id: "marketplace_accounts_jobposting",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <JobPosting
            category={category}
            type={type}
            integrations={integrations}
            onUpdate={onUpdate}
            selectedModule={selectedModule}
          />
        </div>
      ),
    },
  ];
  const AItabs=[
    {
      title: "Kult AI Integration",
      id: "marketplace_accounts_aiintegration",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <OpenaiSettings
            category={category}
            type={type}
            integrations={integrations}
            onUpdate={onUpdate}
            selectedModule={selectedModule}
          />
        </div>
      ),
    },
  ]
  const voipTabList = [
    {
      title: "VOIP Accounts",
      id: "marketplace_accounts_voip",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <BulkEmail
            category={category}
            type={type}
            integrations={integrations}
            onUpdate={onUpdate}
            selectedModule={selectedModule}
          />
        </div>
      ),
    },
  ];
  const bulkmailTabList = [
    {
      title: "Bulk Email",
      id: "marketplace_accounts_bulkemail",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <BulkEmail
            category={category}
            type={type}
            integrations={integrations}
            onUpdate={onUpdate}
            selectedModule={selectedModule}
          />
        </div>
      ),
    },
  ];
  const productivityTabList = [
    {
      title: "Connected Accounts",
      id: "marketplace_accounts_productivity",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <ProductivityAccounts
            category={category}
            type={type}
            integrations={integrations}
            onUpdate={onUpdate}
            selectedModule={selectedModule}
          />
        </div>
      ),
    },
  ];
  const EmailVerificationTabs = [
    {
      title: "Connected Accounts",
      id: "marketplace_accounts_emailverification",
      page: (
        <div className="flex-1 p-2 flex flex-col">
          <EmailVerification
            category={category}
            type={type}
            integrations={integrations}
            onUpdate={onUpdate}
            selectedModule={selectedModule}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="my-2">
      <VerticalTabs
        tabs={
          category === 1
            ? voipTabList : category === 3
            ? monsterTabList : category === 7
            ? productivityTabList : category === 6
            ? AItabs : category === 12
            ? EmailVerificationTabs : bulkmailTabList
        }
        activeColor="primary"
        activeVariant="contained"
      />
    </div>
  );
};

export default MarketPlaceAccounts;
